import React from 'react';
import logo_acto from '../assets/acto.png';
import logo_sightcity from '../assets/sightcity.png';

const Header = () => {

    return (
      <header className={"container-fluid"}>
          <div className={"container"}>
              <div className={"row"}>
                  <div className={"col-12 col-md-6 text-center"}>
                      <img src={logo_acto} className={"logos"} alt={"Logo ACTO"} />
                  </div>
                  <div className={"col-12 col-md-6 text-center"}>
                      <img src={logo_sightcity} className={"logos"} alt={"Logo SightCity Forum"} />
                  </div>
              </div>
          </div>
      </header>
    );
};

export default Header;
